import React from "react";
import { FormikErrors } from "formik";
import ReactDatePicker from "react-datepicker";
import classNames from "classnames";

type CustomDatePickerProps = {
  label?: string;
  error?: FormikErrors<FormData | Date>;
  customClass?: string;
  value?: Date | null;
  handleChange: (date: Date | null) => void;
  name?: string;
};

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
  label,
  error,
  customClass,
  value: _value,
  handleChange,
  name,
}) => {
  const value = _value ? new Date(_value) : null;
  const datePickerClass = classNames(
    "border-slate-300 rounded p-2 border w-full h-11",
    { "border-red-500": !!error },
    customClass,
  );
  return (
    <div className="mb-2">
      {label && (
        <label className="block font-medium" htmlFor={name}>
          {label}
        </label>
      )}
      <div className="relative [&>div]:w-full">
        <ReactDatePicker
          dateFormat={"dd/MM/yyyy"}
          className={datePickerClass}
          selected={value}
          onChange={handleChange}
          name={name}
        />
      </div>
      {error && <div className="error text-red-500">{<>{error}</>}</div>}
    </div>
  );
};

export default CustomDatePicker;
